<template>
  <el-row>
    <!-- :before-upload="beforeUpload" -->
    <el-upload
      class="upload-demo"
      drag
      v-bind="$attrs"
      :action="action"
      :limit="1"
      :show-file-list="true"
      :before-upload="beforeUploads"
      :on-success="handleSuccess"
      :on-progress="onProgress"
      :on-error="onError"
      :on-exceed="handleExceed"
      :headers="headers"
      :before-remove="beforeRemove"
      >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
    <el-row style="height: 40px;">
      <!-- <p v-if="imageUrl != null && imageUrl != ''">提示：<span style="color: #409EFF;">上传成功!</span>
        <i class="el-icon-close c_p" @click="delInfo" style="float: right;margin-right:20px;"></i>
      </p> -->
    </el-row>
  </el-row>
</template>

<script>

export default {
  name: 'UploadFile',
  props: {
    uploadStyle: {
      type: Object,
      detault: {
        width: '178px',
        height: '178px'
      }
    },
    isPdf:{
      type:Boolean,
      detault:function(){
        return false;
      }
    }
  },
  data() {
    return {
      headers: {
        token: this.$getToken()
      },
      action: this.$baseUrl + '/api/file/update.do',
      imageUrl: this.value,
      loading:null
    }
  },
  methods: {
    // 上传之前，可以做一些校验
    beforeUpload(file) {
      console.log('beforeUpload')
      const isLt5M = file.size / 1024 / 1024 < 50
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 50MB!')
      }
      return isLt5M
    },
    handleExceed(files, fileList) {
      this.$message.warning("超出了文件上限!");
    },
    beforeRemove(file, fileList) {
      this.imageUrl = "";
      // this.$emit('onSuccess', res.data.url)
      this.$emit('onSuccess', {});
      return true;
    },
    beforeUploads(file){ //上传前
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },

    // 上传中
    onProgress() {
      console.log('onProgress')
      this.$emit('onProgress')
    },

    // 上传成功后的回调
    handleSuccess(res, file) {
      console.log('success', res)
      this.loading.close();
      if(res.code == 0){
        // this.imageUrl = URL.createObjectURL(file.raw);
        this.imageUrl = this.$isHttp(res.data.url);
        // this.$emit('onSuccess', res.data.url)
        this.$emit('onSuccess', res.data)
      }else{
        this.$message.error(res.msg);
      }
    },

    // 上传失败后的回调
    onError() {
      this.loading.close();
      console.log('onError');
      this.$emit('onError');
    },
    delInfo(){ //删除文件
      this.imageUrl = null;
      this.$emit('onSuccess', {});
    }
  }
}
</script>

<style scoped>
.image-upload ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.image-upload ::v-deep .el-upload:hover {
  border-color: #409EFF;
}
.image-upload-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadFile/index.vue